<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th>NO.</th>
          <th>Origin and destination</th>
          <th>Origin Direction</th>
          <th>Service Time</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(exp,index) in express" :key="index">
          <td v-bind:rowspan="calcula(exp.lines) + 1">{{ exp.no }}</td>
          <td v-bind:rowspan="calcula(exp.lines) + 1">{{ exp.dest }}</td>
          <td v-bind:class="{ 'hidden' : calcula(exp.lines) > 0 }"></td>
          <td v-bind:class="{ 'hidden' : calcula(exp.lines) > 0 }"></td>
        </tr>
        <tr v-for="(line,index2) in exp.lines" :key="index2">
          <td>{{ line.dir }}</td>
          <td>{{ line.time }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      express: [
        {
          no: "Airport Express Line 2",
          dest: "Shenzhen airport - Luohu Railway Station",
          lines: [
            {
              dir: "To Luohu Railway Station",
              time: "07:45 - 24:00"
            },
            {
              dir: "To Shenzhen airport",
              time: "06:30 - 22:00"
            }
          ]
        },
        {
          no: "Airport Express Line 3",
          dest: "Shenzhen airport - Longgang Jiadebao",
          lines: [
            {
              dir: "To Longgang Jiadebao",
              time: "08:00 - 22:00"
            },
            {
              dir: "To Shenzhen airport",
              time: "06:20 - 20:30"
            }
          ]
        },
        {
          no: "Airport Express Line 4",
          dest: "Shenzhen airport - longgang pinghu South City",
          lines: []
        }
      ]
    };
  },
  created() {
    //console.log(this.express[0].lines.length)
  },

  methods:{
    calcula(lineas){
      
      //console.log(lineas)
      var count = lineas.length
      //console.log(count)
      return count
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table {
  width: 100%;
  margin-bottom: 0 !important;
}
table,
th {
  text-align: center;
  width: 25%;
}
th,
td {
  border: 1px solid #eee;
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue